import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const History = ({ center, children = '' }) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
            <FullWrapper isMargin={false} className="main-title">
                <div className="main-title__main-wrap">
                    <div
                        className={`main-title__main-container ${
                            center && 'main-title__main-container--center'
                        }`}
                    >
                        <ScrollAnimation
                            animateIn="fadeIn"
                            delay={500}
                            offset={0}
                            animateOnce={true}
                            duration={1}
                            className="main-title__text-container"
                        >
                            <div className="history-title__description">
                                Агентство «Вебпрактик» работает с ГАП «Ресурс» с 2016 года,
                                оказывает информационную и техническую поддержку сайтов компании.
                                Основной сайт{' '}
                                <a
                                    href="https://www.gapresurs.ru/"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    www.gapresurs.ru
                                </a>{' '}
                                за семь лет неоднократно модернизировали: добавили каталог продукции
                                по торговым маркам и внутренние разделы, сделали адаптив старой
                                версии и точечно изменили дизайн. Но системного обновления не было,
                                из-за чего потерялась целостность сценариев взаимодействия фронта и
                                бэка. Также было необходимо обновить интерфейс, чтобы он
                                соответствовал имиджу технологичной агрокомпании.
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div
                        className="main-title__info-container"
                        style={children ? { display: 'block' } : { display: 'none' }}
                    >
                        {children}
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default History;
